import React from 'react'
import { ReactTypeformEmbed } from 'react-typeform-embed'

export function StemUpgradeScreen() {
  return <ReactTypeformEmbed url='https://justmote.typeform.com/to/dANGUIYl' />
}
